<template>
  <div>
    <div class="vehicle-popup">
      <Input placeholder="Inventory No" :isRequired="true" :inputValue.sync="data.Inv_No" :isDisabled="data.disabledInvNo" ref="Lorry_No" style="padding-right: 10px;"/>
      <Input placeholder="Inventory Code" :isRequired="true" :inputValue.sync="data.Inv_Code" :isDisabled="data.disabledInvCode" ref="VehicleCode"/>
    </div>
    
    <TabView :tabs="tabs" :viewMode="data.viewMode" :activeTab.sync="data.tabIndex" :loadingPage.sync="loadingTab" :loadingName.sync="loadingName" style="margin-top: 5px;"
      @tabChanged="tabChanged"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import TabView from '@/components/TabView.vue';

export default {
  components: {
    Input, TabView
  },
  props: {
    tabs: { type: Array, default: function() { return [] } },
    data: { type: Object, default: function() { return {} } },

    loadingTab: { type: Boolean, default: false },
    loadingName: { type: String, default: '' },

    focusTo: { type: String, default: '' },
  },
  methods: {
    attachmentsAdded: function(items, remarks) {
      for (var i = 0; i < items.length; i++) {
        var reader = new FileReader();
        reader.readAsDataURL(items[i]);
        var current = items[i];

        reader.onload = () => {
          this.tabs[5].data.attachmentItems.push({
            attachmentaction : 'N',
            ID : '',
            FileName : current.name,
            Remarks : remarks,
            Attachment : reader.result.split(',')[1]
          });
        };
      }
    },
    attachmentsDeleted: function(items) {
      items.forEach((i) => {
        var index = this.tabs[5].data.attachmentItems.indexOf(i);
        this.tabs[5].data.attachmentItems.splice(index, 1);

        if (i.ID) {
          this.data.deletedAttachments.push(i);
        }
      });
    },
    tabChanged: function(index) {
      if (!this.focusTo) {
        return;
      }
      switch (index) {
        case 0:
          this.$bus.$emit('vehicleGeneralFocusElement', this.focusTo);
          break;
      }

      this.focusTo = '';
    }
  },
  mounted() {
    this.$bus.$on('attachmentsAdded', this.attachmentsAdded);
    this.$bus.$on('attachmentsDeleted', this.attachmentsDeleted);
  },
  watch: {
    data: {
      deep: true,
      handler: function(val) {
        
        if (val.focusElement) {
          if (val.focusElement == 'Lorry_No' || val.focusElement == 'VehicleCode') {
            this.$refs[val.focusElement].setFocus();
          } 
          else if ( val.focusElement == 'VehicleCategory' || val.focusElement == 'Company_code' || val.focusElement == 'OwnerShip') {
            if (val.tabIndex != 0) {
              this.loadingTab = true;
              this.loadingName = 'General';
              this.focusTo = val.focusElement;

              setTimeout(() => {
                this.data.tabIndex = 0;
              }, 25);
            } else {
              this.$bus.$emit('vehicleGeneralFocusElement', val.focusElement);
            }
          } 
          
          this.data.focusElement = '';
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.vehicle-popup{
  display: flex;
}
</style>